import { createSelector } from 'reselect';

import type { RootState } from 'typesafe-actions';

import type { ProviderDetailsState } from './reducer';

export const getErrors = (state: RootState) => state.providerDetails.errors;

export const getProviderDetailsState = (state: RootState) => state.providerDetails;

export const getProviderDetails = createSelector(
  getProviderDetailsState,
  (state: ProviderDetailsState) => state.providerDetails,
);

export const getIsFetching = createSelector(
  getProviderDetailsState,
  (state: ProviderDetailsState) => state.isFetching,
);
